import React from "react";
import { useScrollReveal } from "./useAnimations";
import "./WhyDigiryte.scss";

const rows = [
  {
    old: "Team-heavy delivery teams",
    digiryte: "Senior-led, right-sized teams",
  },
  {
    old: "Open-ended billing cycles",
    digiryte: "Fixed-scope, outcome-defined pricing",
  },
  {
    old: "Strategy handed off to a separate delivery partner",
    digiryte: "Advisory and delivery as one integrated model",
  },
  { old: "Months to mobilise", digiryte: "Weeks to first outcome" },
  {
    old: "Outputs measured in documents",
    digiryte: "Outputs measured in decisions made and systems built",
  },
];

const WhyDigiryte = () => {
  const [hRef, hVis] = useScrollReveal();
  const [tRef, tVis] = useScrollReveal({ threshold: 0.1 });
  const [imgRef, imgVis] = useScrollReveal({ threshold: 0.15 });

  return (
    <section className="compare">
      <div className="compare__inner">
        <div className="compare__top">
          <div ref={hRef} className="compare__header">
            <span className={`compare__label${hVis ? " is-visible" : ""}`}>
              Why digiRyte
            </span>
            <h2 className={`compare__title${hVis ? " is-visible" : ""}`}>
              What &#8216;Big 4 Grade&#8217;
              <br />
              Actually Means
            </h2>
            <p className={`compare__subtitle${hVis ? " is-visible" : ""}`}>
              The Big 4 built their model for a different era - large teams,
              long timelines and engagements designed to extend, not conclude.
              digiRyte was built to replace that model where it no longer serves
              you.
            </p>
          </div>

          <div
            ref={imgRef}
            className={`compare__img${imgVis ? " is-visible" : ""}`}
          >
            <img
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=600&q=80"
              alt="Team strategy session"
              loading="lazy"
            />
          </div>
        </div>

        <div
          ref={tRef}
          className={`compare__table${tVis ? " is-visible" : ""}`}
        >
          <div className="compare__table-head">
            <div className="compare__col compare__col--old">
              Traditional Consultancy
            </div>
            <div className="compare__col compare__col--new">digiRyte</div>
          </div>
          {rows.map((r, i) => (
            <div
              key={i}
              className={`compare__row${tVis ? " is-visible" : ""}`}
              style={{ transitionDelay: `${0.1 + i * 0.07}s` }}
            >
              <div className="compare__cell compare__cell--old">{r.old}</div>
              <div className="compare__cell compare__cell--new">
                <span className="compare__check">&#10003;</span>
                {r.digiryte}
              </div>
            </div>
          ))}
        </div>

        <p className={`compare__tagline${hVis ? " is-visible" : ""}`}>
          <em>AI accelerates the work.</em> Senior judgement steers it.
        </p>
      </div>
    </section>
  );
};

export default WhyDigiryte;
